module.exports = __webpack_public_path__ + "static/media/warning.c97fb64e.png";